import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Deconstruct extends OBase {
  update () {
    let valTree = this.getVector3Input('Point', false);
    let xOutput = this.getGenericObjectOutput('X component');
    let yOutput = this.getGenericObjectOutput('Y component');
    let zOutput = this.getGenericObjectOutput('Z component');

    var outXTree = new Geometry.DataTree();
    var outYTree = new Geometry.DataTree();
    var outZTree = new Geometry.DataTree();
    for (let i = 0; i < valTree.branches.length; i++) {

      if(valTree.branches[i].length == 0){
        let path = valTree.paths[i];
        outXTree.addEmpty(path);
        outYTree.addEmpty(path);
        outZTree.addEmpty(path);
        continue;
      }

      for (let j = 0; j < valTree.branches[i].length; j++) {
        let point = valTree.branches[i][j];

        outXTree.add(point.x, valTree.paths[i]);
        outYTree.add(point.y, valTree.paths[i]);
        outZTree.add(point.z, valTree.paths[i]);
      }
    }

    xOutput.value = outXTree;
    yOutput.value = outYTree;
    zOutput.value = outZTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Deconstruct.js